export const DEFAULT_FUSE_SETTINGS = {
  threshold: 0.4,
  ignoreLocation: true,
};
